import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ResetPasswordFormComponent } from './change-password/reset-password-form/reset-password-form.component';
import { ChangePasswordFormComponent } from './change-password/change-password-form/change-password-form.component';
import { GenericConfirmationComponent } from './components/generic-confirmation/generic-confirmation.component';
import { CarrierService } from './services/carrier.service';
import { CurrencyService } from './services/currency.service';
import { DocumentService } from './services/document.service';
import { FormInvalidatorService } from './services/form-invalidator.service';
import { SystemSettingsService } from './services/system.settings.service';
import { ConnectionLostService } from './services/connection-lost.service';
import { HomeRoutingModule } from './home-routing.module';
import { SummaryComponent } from '../order/summary/summary.component';
import { OrdersConfirmationComponent } from '../order/orders-confirmation/orders-confirmation.component';
import { OrdersRejectionComponent } from '../order/orders-rejection/orders-rejection.component';
import { SharedModule } from '../../../shared/shared.module';
import { InternetConnectionComponent } from './internet-connection/internet-connection.component';

@NgModule({
  imports: [CommonModule, HomeRoutingModule, SharedModule],
  declarations: [
    DashboardComponent,
    InternetConnectionComponent,
    ChangePasswordComponent,
    ResetPasswordFormComponent,
    ChangePasswordFormComponent,
    GenericConfirmationComponent,
    SummaryComponent,
    OrdersConfirmationComponent,
    OrdersRejectionComponent,
  ],
  providers: [
    CarrierService,
    CurrencyService,
    DocumentService,
    FormInvalidatorService,
    SystemSettingsService,
    ConnectionLostService,
  ],
})
export class HomeModule {}
